import { api } from ".";
import { BASE_URL, DOMAIN } from "../utils/constants";

// export const getForm = async ({ name }) => {
//   return await api.get("/wfm/web-form", {
//     "filter[name]": name,
//   });
// };

export const getForm = async ({ name }) => {
  return await api.get("/wfm/form", {
    "filter[name]": name,
  });
};
export const getMerchant = async () => {
  return await api.get(`/crm/integration/viewMerchantV3`, {
    domain: DOMAIN,
  });
};

export const getMdaForm = async ({ name }) => {
  return await api.get("/wfm/form", {
    "filter[name]": name,
  });
};

export const getMdaMerchant = async (selectedId) => {
  // Or remove all headers
  api.deleteHeader("Authorization");
  return await api.get(`/crm/integration/viewMerchantV3`, {
    domain: selectedId,
  });
};
export const getSurveyForm = async ({ name, email="" }) => {
  let params = {
    name,
  };
  if(email) params.email = email;
  console.log("Fetching survey form with params:", params);
  return await api.get("/wfm/forms/survey-form", params);
};

export const postForm = async ({ token, data, tenantId = null, accessToken, type, selectedOption }) => {
  let url = "";

  if (type === "capture") {
    url = "/wfm/form/create-record"
  } else if (type === "internal") {
    url = "/wfm/form/create-work-order-internal"
  } else {
    url = "/wfm/form/create-work-order"
  }
  
  //bedc-wfm-staging.convergenceondemand.net/wfmservice/form

  if (type === "internal" && tenantId) {
    api.setHeaders({
      // "Tenant-ID": tenantId,
      "X-SSO-ACCESS-TOKEN": accessToken,
    });
  }

  if (type === 'mda') {
    api.deleteHeader("Domain");
    api.setHeaders({
      "X-SSO-ACCESS-TOKEN": accessToken,
      domain:selectedOption?.tenantId
    });
  }

  if (type === "capture") {
    api.deleteHeader("Domain");
    api.setHeaders({
      "X-SSO-ACCESS-TOKEN": accessToken,
      domain: tenantId
    })
  }

  api.setHeaders({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  });


  return await api.post(url, data);
};

export const uploadFiles = async ({ token, data }) => {
  api.setHeaders({
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
  });
  return await api.post("/wfm/web-form/work-order-attachment", data);
};

// Sample Draft APIs
export const saveSurveyDraft = async ({ data, token }) => {
  // Replace with target survey draft endpoint
  api.setHeaders({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  });
  return await api.post("/wfm/survey/save-draft", data);
};

export const getSurveyDraft = async ({ formName, token }) => {
  // Replace with target survey draft retrieval endpoint
  api.setHeaders({
    Authorization: `Bearer ${token}`,
  });
  return await api.get(`/wfm/survey/get-draft`, {
    "filter[name]": formName
  });
};

// Sample Survey Submission API
export const submitSurveyData = async ({ data, token }) => {
  api.setHeaders({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  });
  return await api.post("/wfm/survey/submit-response", data);
};


